<script>
  export let assetsPath = './';
  let width = null;
  import { onMount } from 'svelte';
  export let onAiMounted = () => {};
  onMount(() => {
    onAiMounted();
  });
</script>

<div id="g-ice-skate-Blade-box" bind:clientWidth={width}>
  <!-- Artboard: xs -->
  {#if width && width >= 0 && width < 660}
    <div id="g-ice-skate-Blade-xs" class="g-artboard" style="">
      <div style="padding: 0 0 212.6804% 0;"></div>
      <div
        id="g-ice-skate-Blade-xs-img"
        class="g-aiImg"
        alt=""
        style="background-image: url({assetsPath.replace(
          new RegExp('/([^/.]+)$'),
          '/$1/'
        ) || '/'}images/graphics/ice-skate-Blade-xs.jpg);"
      ></div>
      <div
        id="g-ai0-1"
        class="g-text g-aiAbs g-aiPointText"
        style="top:36.8007%;margin-top:-13.3px;left:87.3116%;width:52px;"
      >
        <p class="g-pstyle0">Heel</p>
        <p class="g-pstyle0">plate</p>
      </div>
      <div
        id="g-ai0-2"
        class="g-text g-aiAbs g-aiPointText"
        style="top:42.8273%;margin-top:-5.6px;left:1.2655%;width:66px;"
      >
        <p class="g-pstyle0">Toepick</p>
      </div>
      <div
        id="g-ai0-3"
        class="g-text g-aiAbs"
        style="top:48.7287%;left:28.2516%;width:52.7273%;"
      >
        <p class="g-pstyle1">
          Curve increases towards front of skate where spinning, jumping and
          turning takes place.
        </p>
      </div>
      <div
        id="g-ai0-4"
        class="g-text g-aiAbs"
        style="top:62.9768%;left:15.8251%;width:68.4848%;"
      >
        <p class="g-pstyle1">
          The blade is concave and creates two edges that allow the skater much
          more control in speed and direction.
        </p>
      </div>
      <div
        id="g-ai0-5"
        class="g-text g-aiAbs g-aiPointText"
        style="top:73.4608%;margin-top:-5.6px;left:51.6954%;margin-left:-60px;width:120px;"
      >
        <p class="g-pstyle2">Blade edge view</p>
      </div>
      <div
        id="g-ai0-6"
        class="g-text g-aiAbs g-aiPointText"
        style="top:76.3104%;margin-top:-7.6px;left:49.374%;margin-left:-31.5px;width:63px;"
      >
        <p class="g-pstyle3">4.7mm</p>
      </div>
      <div
        id="g-ai0-7"
        class="g-text g-aiAbs g-aiPointText"
        style="top:79.0176%;margin-top:-7.6px;left:88.3395%;margin-left:-45.5px;width:91px;"
      >
        <p class="g-pstyle3">Skate blade</p>
      </div>
      <div
        id="g-ai0-8"
        class="g-text g-aiAbs g-aiPointText"
        style="top:81.8056%;margin-top:-17.1px;left:6.3952%;width:68px;"
      >
        <p class="g-pstyle4">Outside</p>
        <p class="g-pstyle4">edge</p>
      </div>
      <div
        id="g-ai0-9"
        class="g-text g-aiAbs g-aiPointText"
        style="top:84.9402%;margin-top:-17.1px;right:28.0868%;width:60px;"
      >
        <p class="g-pstyle5">Inside</p>
        <p class="g-pstyle5">edge</p>
      </div>
      <div
        id="g-ai0-10"
        class="g-text g-aiAbs g-aiPointText"
        style="top:92.4108%;margin-top:-7.6px;left:36.8753%;margin-left:-57.5px;width:115px;"
      >
        <p class="g-pstyle3">Contact with ice</p>
      </div>
      <div
        id="g-ai0-11"
        class="g-text g-aiAbs g-aiPointText"
        style="top:95.1824%;margin-top:-14px;left:63.7185%;width:99px;"
      >
        <p class="g-pstyle6">A matchstick</p>
        <p class="g-pstyle6">for scale</p>
      </div>
    </div>
  {/if}
  <!-- Artboard: md -->
  {#if width && width >= 660 && width < 930}
    <div id="g-ice-skate-Blade-md" class="g-artboard" style="">
      <div style="padding: 0 0 165.0871% 0;"></div>
      <div
        id="g-ice-skate-Blade-md-img"
        class="g-aiImg"
        alt=""
        style="background-image: url({assetsPath.replace(
          new RegExp('/([^/.]+)$'),
          '/$1/'
        ) || '/'}images/graphics/ice-skate-Blade-md.jpg);"
      ></div>
      <div
        id="g-ai1-1"
        class="g-text g-aiAbs g-aiPointText"
        style="top:40.0766%;margin-top:-9.7px;left:78.7272%;width:91px;"
      >
        <p class="g-pstyle0">Heel plate</p>
      </div>
      <div
        id="g-ai1-2"
        class="g-text g-aiAbs g-aiPointText"
        style="top:46.6846%;margin-top:-9.7px;left:2.9457%;width:72px;"
      >
        <p class="g-pstyle0">Toepick</p>
      </div>
      <div
        id="g-ai1-3"
        class="g-text g-aiAbs"
        style="top:53.14%;right:66.3636%;width:33.6364%;"
      >
        <p class="g-pstyle1">
          Curve increases towards front of skate where spinning, jumping and
          turning takes place.
        </p>
      </div>
      <div
        id="g-ai1-4"
        class="g-text g-aiAbs"
        style="top:55.9852%;left:38.4682%;width:26.3636%;"
      >
        <p class="g-pstyle2">
          The blade is concave and creates two edges that allow the skater much
          more control in speed and direction.
        </p>
      </div>
      <div
        id="g-ai1-5"
        class="g-text g-aiAbs g-aiPointText"
        style="top:68.2527%;margin-top:-9.7px;left:50.7459%;margin-left:-66.5px;width:133px;"
      >
        <p class="g-pstyle3">Blade edge view</p>
      </div>
      <div
        id="g-ai1-6"
        class="g-text g-aiAbs g-aiPointText"
        style="top:71.5567%;margin-top:-9.7px;left:50.6715%;margin-left:-34.5px;width:69px;"
      >
        <p class="g-pstyle4">4.7mm</p>
      </div>
      <div
        id="g-ai1-7"
        class="g-text g-aiAbs g-aiPointText"
        style="top:78.7155%;margin-top:-9.7px;left:85.2566%;margin-left:-50.5px;width:101px;"
      >
        <p class="g-pstyle4">Skate blade</p>
      </div>
      <div
        id="g-ai1-8"
        class="g-text g-aiAbs g-aiPointText"
        style="top:79.725%;margin-top:-9.7px;left:14.8541%;margin-left:-55.5px;width:111px;"
      >
        <p class="g-pstyle4">Outside edge</p>
      </div>
      <div
        id="g-ai1-9"
        class="g-text g-aiAbs g-aiPointText"
        style="top:82.7537%;margin-top:-9.7px;left:65.8786%;margin-left:-49px;width:98px;"
      >
        <p class="g-pstyle4">Inside edge</p>
      </div>
      <div
        id="g-ai1-10"
        class="g-text g-aiAbs g-aiPointText"
        style="top:90.555%;margin-top:-9.7px;right:70.2998%;width:128px;"
      >
        <p class="g-pstyle5">Contact with ice</p>
      </div>
      <div
        id="g-ai1-11"
        class="g-text g-aiAbs g-aiPointText"
        style="top:93.8055%;margin-top:-16.1px;left:63.9656%;width:99px;"
      >
        <p class="g-pstyle6">A matchstick</p>
        <p class="g-pstyle6">for scale</p>
      </div>
    </div>
  {/if}
  <!-- Artboard: lg -->
  {#if width && width >= 930}
    <div id="g-ice-skate-Blade-lg" class="g-artboard" style="">
      <div style="padding: 0 0 119.5558% 0;"></div>
      <div
        id="g-ice-skate-Blade-lg-img"
        class="g-aiImg"
        alt=""
        style="background-image: url({assetsPath.replace(
          new RegExp('/([^/.]+)$'),
          '/$1/'
        ) || '/'}images/graphics/ice-skate-Blade-lg.jpg);"
      ></div>
      <div
        id="g-ai2-1"
        class="g-text g-aiAbs g-aiPointText"
        style="top:42.151%;margin-top:-9.7px;left:73.358%;width:91px;"
      >
        <p class="g-pstyle0">Heel plate</p>
      </div>
      <div
        id="g-ai2-2"
        class="g-text g-aiAbs g-aiPointText"
        style="top:47.997%;margin-top:-9.7px;left:20.3784%;width:72px;"
      >
        <p class="g-pstyle0">Toepick</p>
      </div>
      <div
        id="g-ai2-3"
        class="g-text g-aiAbs"
        style="top:52.3443%;right:68.4071%;width:23.871%;"
      >
        <p class="g-pstyle1">
          Curve increases towards front of skate where spinning, jumping and
          turning takes place.
        </p>
      </div>
      <div
        id="g-ai2-4"
        class="g-text g-aiAbs"
        style="top:57.4708%;left:45.1526%;width:18.7097%;"
      >
        <p class="g-pstyle2">
          The blade is concave and creates two edges that allow the skater much
          more control in speed and direction.
        </p>
      </div>
      <div
        id="g-ai2-5"
        class="g-text g-aiAbs g-aiPointText"
        style="top:69.4924%;margin-top:-9.7px;left:53.8658%;margin-left:-66.5px;width:133px;"
      >
        <p class="g-pstyle3">Blade edge view</p>
      </div>
      <div
        id="g-ai2-6"
        class="g-text g-aiAbs g-aiPointText"
        style="top:72.7302%;margin-top:-9.7px;left:53.813%;margin-left:-34.5px;width:69px;"
      >
        <p class="g-pstyle4">4.7mm</p>
      </div>
      <div
        id="g-ai2-7"
        class="g-text g-aiAbs g-aiPointText"
        style="top:79.7454%;margin-top:-9.7px;left:78.3573%;margin-left:-50.5px;width:101px;"
      >
        <p class="g-pstyle4">Skate blade</p>
      </div>
      <div
        id="g-ai2-8"
        class="g-text g-aiAbs g-aiPointText"
        style="top:80.7347%;margin-top:-9.7px;left:28.3942%;margin-left:-55.5px;width:111px;"
      >
        <p class="g-pstyle4">Outside edge</p>
      </div>
      <div
        id="g-ai2-9"
        class="g-text g-aiAbs g-aiPointText"
        style="top:83.6127%;margin-top:-9.7px;left:64.6052%;margin-left:-49px;width:98px;"
      >
        <p class="g-pstyle4">Inside edge</p>
      </div>
      <div
        id="g-ai2-10"
        class="g-text g-aiAbs g-aiPointText"
        style="top:91.2575%;margin-top:-9.7px;right:61.0698%;width:128px;"
      >
        <p class="g-pstyle5">Contact with ice</p>
      </div>
      <div
        id="g-ai2-11"
        class="g-text g-aiAbs g-aiPointText"
        style="top:94.5328%;margin-top:-16.1px;left:63.2475%;width:99px;"
      >
        <p class="g-pstyle6">A matchstick</p>
        <p class="g-pstyle6">for scale</p>
      </div>
    </div>
  {/if}
</div>
<!-- End ai2html - 2026-02-20 14:32 -->

<!-- Generated by ai2html v0.100.0 - 2026-02-20 14:32 -->
<!-- ai file: ice-skate-Blade.ai -->
<style lang="scss">
  #g-ice-skate-Blade-box,
  #g-ice-skate-Blade-box .g-artboard {
    margin: 0 auto;
  }
  #g-ice-skate-Blade-box p {
    margin: 0;
  }
  #g-ice-skate-Blade-box .g-aiAbs {
    position: absolute;
  }
  #g-ice-skate-Blade-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-ice-skate-Blade-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-ice-skate-Blade-xs {
    position: relative;
    overflow: hidden;
  }
  #g-ice-skate-Blade-xs p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 14px;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-ice-skate-Blade-xs .g-pstyle0 {
    line-height: 10px;
    height: 10px;
    padding-bottom: 5px;
  }
  #g-ice-skate-Blade-xs .g-pstyle1 {
    padding-bottom: 5px;
  }
  #g-ice-skate-Blade-xs .g-pstyle2 {
    font-weight: 500;
    line-height: 10px;
    height: 10px;
    padding-bottom: 5px;
    text-align: center;
  }
  #g-ice-skate-Blade-xs .g-pstyle3 {
    height: 14px;
    padding-bottom: 5px;
    text-align: center;
  }
  #g-ice-skate-Blade-xs .g-pstyle4 {
    height: 14px;
    padding-bottom: 5px;
  }
  #g-ice-skate-Blade-xs .g-pstyle5 {
    height: 14px;
    padding-bottom: 5px;
    text-align: right;
  }
  #g-ice-skate-Blade-xs .g-pstyle6 {
    font-weight: 300;
    line-height: 11px;
    height: 11px;
    padding-bottom: 5px;
  }
  #g-ice-skate-Blade-md {
    position: relative;
    overflow: hidden;
  }
  #g-ice-skate-Blade-md p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 18px;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-ice-skate-Blade-md .g-pstyle0 {
    height: 18px;
    padding-bottom: 9px;
  }
  #g-ice-skate-Blade-md .g-pstyle1 {
    padding-bottom: 9px;
    text-align: right;
  }
  #g-ice-skate-Blade-md .g-pstyle2 {
    padding-bottom: 9px;
  }
  #g-ice-skate-Blade-md .g-pstyle3 {
    font-weight: 500;
    height: 18px;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-ice-skate-Blade-md .g-pstyle4 {
    height: 18px;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-ice-skate-Blade-md .g-pstyle5 {
    height: 18px;
    padding-bottom: 9px;
    text-align: right;
  }
  #g-ice-skate-Blade-md .g-pstyle6 {
    font-weight: 300;
    line-height: 11px;
    height: 11px;
    padding-bottom: 9px;
    font-size: 14px;
  }
  #g-ice-skate-Blade-lg {
    position: relative;
    overflow: hidden;
  }
  #g-ice-skate-Blade-lg p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 18px;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-ice-skate-Blade-lg .g-pstyle0 {
    height: 18px;
    padding-bottom: 9px;
  }
  #g-ice-skate-Blade-lg .g-pstyle1 {
    padding-bottom: 9px;
    text-align: right;
  }
  #g-ice-skate-Blade-lg .g-pstyle2 {
    padding-bottom: 9px;
  }
  #g-ice-skate-Blade-lg .g-pstyle3 {
    font-weight: 500;
    height: 18px;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-ice-skate-Blade-lg .g-pstyle4 {
    height: 18px;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-ice-skate-Blade-lg .g-pstyle5 {
    height: 18px;
    padding-bottom: 9px;
    text-align: right;
  }
  #g-ice-skate-Blade-lg .g-pstyle6 {
    font-weight: 300;
    line-height: 11px;
    height: 11px;
    padding-bottom: 9px;
    font-size: 14px;
  }

  /* Custom CSS */
  .g-text {
  }
</style>
